import { ARCHIEVEEXPENSE_SUCCESS, ARCHIEVEEXPENSE_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const archieveExpenseReducer = (state = initialState, action) => {
    switch (action.type) {
        case ARCHIEVEEXPENSE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ARCHIEVEEXPENSE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default archieveExpenseReducer;
